import { useMemo } from 'react';
import { SuspensePayment } from './typing';
import { getStoragePayments, saveStoragePayments } from './storage';

export default function useSuspensePaymentStorage(): {
  query: () => SuspensePayment[];
  remove: (identifier: string) => void;
} {
  return useMemo(() => {
    return {
      query: () => {
        return getStoragePayments();
      },
      remove: (identifier: (() => boolean) | string) => {
        const payments = getStoragePayments();
        const predicate: (item: SuspensePayment) => boolean =
          typeof identifier === 'string'
            ? (item: SuspensePayment) => {
                return item.identifier === identifier;
              }
            : identifier;
        saveStoragePayments(
          payments.filter((item) => {
            return !predicate(item);
          }),
        );
      },
    };
  }, []);
}
